import { combineReducers } from 'redux';
import costReports from './costReports.reducer';

const reducer = combineReducers({
	costReports
});

export default reducer;
